import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-display-array-rel',
  template: require('./display-array-rel.component.html'),
  styles: [require('./display-array-rel.component.scss')],
})
export class DisplayArrayRelComponent {
  @Input() field: string;
  @Input() displayKey: string;
  @Input() className: string;
  @Input() value: any;
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/admin/shared/display-array-rel/display-array-rel.component.ts